/* SeattleWallWraps.com — projects gallery (Builder B, "Spatial Scan").
   Space-type filter chips (aria-pressed), bento tile spans recomputed for the visible set,
   and a lightbox with prev/next, Esc, swipe and dimension-tag captions.
   Vanilla JS, one namespace: window.CWV.projects. Works with several instances per page. */
(function () {
  'use strict';

  var CWV = (window.CWV = window.CWV || {});
  if (CWV.projects) return;

  var doc = document;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function lockScroll(on) {
    if (typeof CWV.lockScroll === 'function') { CWV.lockScroll(on); return; }
    doc.documentElement.classList[on ? 'add' : 'remove']('cwv-scroll-lock');
  }

  /* Accessible modal on top of <dialog>: focus trap, Esc, backdrop click, focus return, scroll lock. */
  function makeDialog(d, onClose) {
    var opener = null, open = false;
    var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';
    function items() { return $$(SEL, d).filter(function (el) { return el.getClientRects().length > 0; }); }
    function finish() {
      open = false;
      lockScroll(false);
      if (onClose) onClose();
      if (opener && doc.contains(opener)) focusEl(opener);
      opener = null;
    }
    d.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); api.close(); return; }
      if (e.key !== 'Tab') return;
      var list = items();
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0], last = list[list.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || !d.contains(a))) { e.preventDefault(); focusEl(last); }
      else if (!e.shiftKey && (a === last || !d.contains(a))) { e.preventDefault(); focusEl(first); }
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); api.close(); });
    d.addEventListener('close', function () { if (open) finish(); });
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (t === d || (t && t.hasAttribute && t.hasAttribute('data-cwv-backdrop'))) { api.close(); return; }
      var c = t && t.closest ? t.closest('[data-cwv-close]') : null;
      if (c && d.contains(c)) api.close();
    });
    var api = {
      open: function (from) {
        if (open) return;
        opener = from || doc.activeElement;
        open = true;
        if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
        else d.setAttribute('open', '');
        lockScroll(true);
        focusEl($('[data-cwv-autofocus]', d) || items()[0]);
      },
      close: function () {
        if (!open) return;
        if (typeof d.close === 'function' && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
        else d.removeAttribute('open');
        if (open) finish();
      },
      isOpen: function () { return open; },
      returnTo: function (el) { if (el) opener = el; }
    };
    return api;
  }

  /* Tile spans repeat in cycles that fill whole rows (4 cols: big+wide+6, 3 cols: big+5, 2 cols: wide+4).
     A short final cycle is simplified so filtered sets never leave holes beside a big tile.
     Mirrors the Liquid in sections/cwv-projects.liquid. */
  function spanFor(cols, i, n) {
    var cycle = cols === '4' ? 8 : (cols === '3' ? 6 : 5);
    var pos = i % cycle, left = Math.min(cycle, n - i + pos);
    if (cols === '4') {
      if (left >= 4) return pos === 0 ? 'big' : (pos === 1 ? 'wide' : '');
      if (left === 3) return pos === 0 ? 'wide' : '';
      if (left === 2) return 'wide';
      return '';
    }
    if (cols === '3') return (left >= 3 && pos === 0) ? 'big' : '';
    return pos === 0 ? 'wide' : '';
  }

  function Projects(root) {
    this.root = root;
    this.cols = root.getAttribute('data-cols') || '3';
    this.items = $$('[data-cwv-item]', root);
    this.countEl = $('[data-cwv-count]', root);
    this.emptyEl = $('[data-cwv-empty]', root);
    this.chips = $$('.cwv-pj__filters [data-cwv-filter]', root);
    this.dlgEl = $('[data-cwv-dialog]', root);
    this.idx = -1;
    var self = this;

    this.onClick = function (e) {
      var t = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!t || !root.contains(t) || (self.dlgEl && self.dlgEl.contains(t))) return;
      if (t.hasAttribute('data-cwv-filter')) { self.setFilter(t.getAttribute('data-cwv-filter')); return; }
      if (t.hasAttribute('data-cwv-open')) {
        self.open(self.openable().indexOf(t.closest('[data-cwv-item]')), t);
      }
    };
    root.addEventListener('click', this.onClick);

    if (this.dlgEl) this.setupDialog();
  }

  Projects.prototype.visible = function () { return this.items.filter(function (el) { return !el.hidden; }); };
  Projects.prototype.openable = function () { return this.visible().filter(function (el) { return !!$('[data-cwv-open]', el); }); };

  Projects.prototype.applySpans = function () {
    var cols = this.cols, list = this.visible(), n = list.length;
    list.forEach(function (el, i) {
      var s = spanFor(cols, i, n);
      if (s) el.setAttribute('data-span', s); else el.removeAttribute('data-span');
    });
  };

  Projects.prototype.setFilter = function (key) {
    var label = 'All';
    this.chips.forEach(function (b) {
      var on = b.getAttribute('data-cwv-filter') === key;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) label = b.textContent.trim();
    });
    var shown = 0, animate = !reduced();
    this.items.forEach(function (el) {
      var on = key === 'all' || el.getAttribute('data-cat') === key;
      el.hidden = !on;
      el.classList.remove('is-in');
      if (on) {
        shown += 1;
        if (animate) { void el.offsetWidth; el.classList.add('is-in'); }
      }
    });
    this.applySpans();
    if (this.countEl) {
      this.countEl.textContent = shown + (shown === 1 ? ' project' : ' projects') + (key === 'all' ? '' : ' · ' + label);
    }
    if (this.emptyEl) this.emptyEl.hidden = shown > 0;
  };

  Projects.prototype.setupDialog = function () {
    var self = this, d = this.dlgEl;
    this.lbMedia = $('[data-cwv-lb-media]', d);
    this.lbTitle = $('[data-cwv-lb-title]', d);
    this.lbCat = $('[data-cwv-lb-cat]', d);
    this.lbCount = $('[data-cwv-lb-count]', d);
    this.lbMeta = $('[data-cwv-lb-meta]', d);
    this.lbDesc = $('[data-cwv-lb-desc]', d);
    this.lbStatus = $('[data-cwv-lb-status]', d);
    this.lbPrev = $('[data-cwv-lb-prev]', d);
    this.lbNext = $('[data-cwv-lb-next]', d);
    this.dlg = makeDialog(d, function () {
      if (self.lbMedia) self.lbMedia.innerHTML = '';
      self.idx = -1;
    });
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || !d.contains(b)) return;
      if (b.hasAttribute('data-cwv-lb-prev')) self.show(self.idx - 1);
      else if (b.hasAttribute('data-cwv-lb-next')) self.show(self.idx + 1);
    });
    d.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowLeft' || e.key === 'Left') { e.preventDefault(); self.show(self.idx - 1); }
      else if (e.key === 'ArrowRight' || e.key === 'Right') { e.preventDefault(); self.show(self.idx + 1); }
    });
    var sx = 0, sy = 0, st = 0;
    d.addEventListener('touchstart', function (e) {
      var p = e.touches && e.touches[0];
      if (!p) return;
      sx = p.clientX; sy = p.clientY; st = Date.now();
    }, { passive: true });
    d.addEventListener('touchend', function (e) {
      var p = e.changedTouches && e.changedTouches[0];
      if (!p || Date.now() - st > 700) return;
      var dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) self.show(self.idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };

  Projects.prototype.open = function (i, opener) {
    if (!this.dlg || i < 0) return;
    this.dlg.open(opener);
    this.show(i);
  };

  Projects.prototype.show = function (i) {
    var list = this.openable();
    var n = list.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    this.idx = i;
    var item = list[i];
    var data = $('.cwv-pj__data', item);
    if (!data) return;

    var title = data.getAttribute('data-title') || '';
    var cat = data.getAttribute('data-cat') || '';
    var space = data.getAttribute('data-space') || '';
    var client = data.getAttribute('data-client') || '';
    var count = pad(i + 1) + ' / ' + pad(n);

    if (this.lbTitle) this.lbTitle.textContent = title || data.getAttribute('data-alt') || 'Project';
    if (this.lbCat) this.lbCat.textContent = cat;
    if (this.lbCount) this.lbCount.textContent = 'Project ' + count;
    if (this.lbMeta) {
      /* dimension-tag readouts: SPACE · Reception wall / CLIENT · Name */
      var meta = this.lbMeta;
      meta.innerHTML = '';
      [['Space', space], ['Client', client]].forEach(function (pair) {
        if (!pair[1]) return;
        var tag = doc.createElement('span');
        tag.className = 'cwv-pj__tag';
        var k = doc.createElement('span');
        k.className = 'cwv-pj__tag-k';
        k.textContent = pair[0];
        tag.appendChild(k);
        tag.appendChild(doc.createTextNode(pair[1]));
        meta.appendChild(tag);
      });
    }
    if (this.lbDesc) {
      var desc = $('.cwv-pj__desc', data);
      this.lbDesc.innerHTML = desc ? desc.innerHTML : '';
    }
    if (this.lbPrev) this.lbPrev.hidden = n < 2;
    if (this.lbNext) this.lbNext.hidden = n < 2;

    if (this.lbMedia) {
      var box = this.lbMedia;
      box.innerHTML = '';
      box.classList.add('is-loading');
      /* frame = scanner viewport around the photo: corner anchors + a lime dimension line on top */
      var frame = doc.createElement('span');
      frame.className = 'cwv-pj__lb-frame';
      var dim = doc.createElement('span');
      dim.className = 'cwv-pj__lb-dim';
      dim.setAttribute('aria-hidden', 'true');
      var dimLabel = doc.createElement('span');
      dimLabel.className = 'cwv-pj__lb-dim-label';
      dimLabel.textContent = (space || cat || 'Project') + ' · ' + count;
      dim.appendChild(dimLabel);
      var img = doc.createElement('img');
      img.alt = data.getAttribute('data-alt') || title;
      img.decoding = 'async';
      img.addEventListener('load', function () { box.classList.remove('is-loading'); frame.classList.add('is-loaded'); img.classList.add('is-loaded'); });
      img.addEventListener('error', function () { box.classList.remove('is-loading'); });
      img.src = data.getAttribute('data-full') || '';
      frame.appendChild(img);
      frame.appendChild(dim);
      box.appendChild(frame);
    }
    if (this.lbStatus) this.lbStatus.textContent = 'Project ' + (i + 1) + ' of ' + n + (title ? ': ' + title : '');
    var opener = $('[data-cwv-open]', item);
    if (this.dlg && opener) this.dlg.returnTo(opener);
  };

  Projects.prototype.selectBlock = function (el) {
    var item = el.closest ? el.closest('[data-cwv-item]') : null;
    if (!item || this.items.indexOf(item) < 0) return;
    if (item.hidden) this.setFilter('all');
    try { item.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { item.scrollIntoView(); }
  };

  Projects.prototype.destroy = function () {
    if (this.dlg && this.dlg.isOpen()) this.dlg.close();
    this.root.removeEventListener('click', this.onClick);
  };

  function init(scope) {
    $$('[data-cwv-projects]', scope).forEach(function (el) { if (!el.cwvProjects) el.cwvProjects = new Projects(el); });
  }
  function destroy(scope) {
    $$('[data-cwv-projects]', scope).forEach(function (el) {
      if (el.cwvProjects && el.cwvProjects.destroy) el.cwvProjects.destroy();
      el.cwvProjects = null;
    });
  }

  CWV.projects = { init: init, destroy: destroy };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var root = t && t.closest ? t.closest('[data-cwv-projects]') : null;
    if (root && root.cwvProjects) root.cwvProjects.selectBlock(t);
  });
})();
